<template>
  <EditorialPost v-if="post" :post="post" />
</template>

<script setup lang="ts">
import type { QueryEditorial } from "~/@types/editorial"
import { getBySlugSection } from "~/groq/editorial"

const route = useRoute()
const img = useImage()

const { data: post } = await useSanityQuery<QueryEditorial>(
  getBySlugSection(),
  {
    section: route.params.section,
    slug: route.params.slug,
  },
)

if (!post.value || isEmpty(post.value)) {
  throw createError({
    statusCode: 404,
    statusMessage: "Page not found",
  })
}

const { title, section, metaDescription, metaTitle, _updatedAt, metaImage } =
  useEditorial(post.value)

useHead({
  templateParams: {
    section: section.name,
  },
  title: metaTitle ?? title,
  titleTemplate: metaTitle
    ? "%s %separator %siteName"
    : "%s | %section %separator Editorial %separator %siteName",
})

const description = metaDescription
  ? { description: metaDescription.replace(/(\r\n|\n|\r)/gm, "") }
  : {}

const ogImage = metaImage?.asset?._ref
  ? {
      url: img(metaImage.asset?._ref, {
        width: 1200,
        height: 630,
        fit: "crop",
      }),
      width: 1200,
      height: 630,
    }
  : {}

useSeoMeta({
  ogTitle: metaTitle ?? title,
  articleModifiedTime: _updatedAt,
  ...description,
})

if (ogImage) {
  defineOgImage(ogImage)
}
</script>
